/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */

// TODO(yassogba) migrate these to the new convention
import './square';
import './fromPixels';
import './non_max_suppression_v5';

import {registerKernel} from '../../kernel_registry';
// TODO(yassogba) import from tensorflow/tfjs-core once core stops importing
// this file.
import {KernelConfig} from '../../kernel_registry';

// Import Kernel Configs here.
import {squaredDifferenceConfig} from './kernels/SquaredDifference';

// List all kernel configs here
const kernelConfigs: KernelConfig[] = [
  squaredDifferenceConfig,
];

for (const kernelConfig of kernelConfigs) {
  registerKernel(kernelConfig);
}
